module.exports = __webpack_public_path__ + "e9d7069d95446220da221145b03c17e5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/ic_home_active_24.svg
// module id = 1085
// module chunks = 3